/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "fulfillment": {
        "nested": {
          "behaviors": {
            "nested": {
              "common": {
                "nested": {
                  "MoneyRange": {
                    "fields": {
                      "minimum": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "maximum": {
                        "type": ".squareup.connect.v2.common.Money",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "TimeRange": {
                    "fields": {
                      "minimum": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "maximum": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.MoneyRange && !$root.nested?.squareup?.nested?.fulfillment?.nested?.behaviors?.nested?.common?.nested?.TimeRange) {
  $root.addJSON(jsonData);
}

/**
 * Range for monetary amounts (minimum and/or maximum bounds).
 * Used for order subtotal constraints, fee limits, and pricing tiers.
 * Both bounds are inclusive when specified.
 *
 * SOURCE MoneyRange @ squareup/fulfillment/behaviors/common/common.proto at 42:1
 */
export const MoneyRange = $root.lookupType('squareup.fulfillment.behaviors.common.MoneyRange');
fixType(MoneyRange);
Builder.createAndAttachToType(MoneyRange);
/**
 * Range for time durations (minimum and/or maximum bounds).
 * Used for delivery time estimates and scheduling constraints.
 * Both bounds are inclusive when specified.
 *
 * SOURCE TimeRange @ squareup/fulfillment/behaviors/common/common.proto at 63:1
 */
export const TimeRange = $root.lookupType('squareup.fulfillment.behaviors.common.TimeRange');
fixType(TimeRange);
Builder.createAndAttachToType(TimeRange);